"use client";

import dynamic from "next/dynamic";
import { useMemo } from "react";
import { rocketPlacementsForDisplay } from "@/lib/game/rocket";
import { useGame } from "../GameProvider";

const PixiRocketBadge = dynamic(
  () => import("./PixiRocketBadge").then((m) => m.PixiRocketBadge),
  { ssr: false },
);

interface ActivityRocketBuddyProps {
  size?: number;
  className?: string;
}

export function ActivityRocketBuddy({ size = 76, className = "" }: ActivityRocketBuddyProps) {
  const { progress } = useGame();
  const placements = useMemo(
    () => rocketPlacementsForDisplay(progress.builtRocket),
    [progress.builtRocket],
  );

  return (
    <div
      className={`pointer-events-none absolute top-2 right-2 z-[5] sm:top-3 sm:right-3 ${className}`}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <PixiRocketBadge placements={placements} size={size} className="h-full w-full" />
    </div>
  );
}
